<template>
    <!--DIALOG PROCESANDO DATA-->
    <v-dialog v-model="procesando" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ message }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
  props:{
    procesando:{
      type:Boolean,
      default:false,
      require: true
    },
    message:{
      type:String,
      default:'Procesando Solicitud...',
      required:false
    }
  },
    
}
</script>